import { render, staticRenderFns } from "./StoresComponent.vue?vue&type=template&id=0ad1c346&scoped=true&"
import script from "./StoresComponent.vue?vue&type=script&lang=js&"
export * from "./StoresComponent.vue?vue&type=script&lang=js&"
import style0 from "./StoresComponent.vue?vue&type=style&index=0&id=0ad1c346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1c346",
  null
  
)

export default component.exports